import { Routes, Route } from "react-router-dom";
import MyPage from "default/pages/MyPage";
import Quests from "default/pages/QuestGroups";
import HowToUse from "default/pages/HowToUse";
import EmailSettings from "default/pages/EmailSettings";
import News from "default/pages/News";

import Tickets from "works/jashindp/pages/Tickets";
import Halloween from "works/jashindp/pages/Halloween";

import PayPayTicketConfirm from "default/pages/PayPayTicketConfirm";
import PayPayConfirm from "default/pages/PayPayConfirm";
import PayPayCheck from "default/pages/PayPayCheck";
import PayPayPolling from "default/pages/PayPayPolling";

export default function jashindpRoutes() {
  return (
    <Routes>
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/quests" element={<Quests />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/email-settings" element={<EmailSettings />} />
      <Route path="/news" element={<News />} />
      <Route path="/halloween" element={<Halloween />} />

      <Route path="/confirm-paypay" element={<PayPayTicketConfirm />} />
      <Route path="/check-paypay" element={<PayPayCheck />} />
      <Route path="/paypay-polling" element={<PayPayPolling />} />

      <Route path="/paypay/confirm" element={<PayPayConfirm />} />
      <Route path="/paypay/polling" element={<PayPayPolling />} />
      <Route path="/paypay/check" element={<PayPayCheck />} />
    </Routes>
  );
}
